import React from 'react';
import {
  Button,
  Space,
  Typography,
} from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import {
  RuntimeErrorState,
} from '../common/runtime';
import RuntimeExecutionDetailPanel from './runtime/RuntimeExecutionDetailPanel';

const { Title, Text } = Typography;

const PlatformRuntimeExecutionDetail = () => {
  const navigate = useNavigate();
  const { executionId } = useParams();
  const normalizedExecutionId = String(executionId || '').trim();

  if (!normalizedExecutionId) {
    return (
      <div style={{ padding: 24 }}>
        <RuntimeErrorState
          title="Execution ID invalido"
          description="Nao foi possivel identificar a execucao solicitada."
          onRetry={() => navigate('/platform/saas-billing/runtime/history')}
          retryLabel="Voltar para Runtime History"
        />
      </div>
    );
  }

  return (
    <div style={{ padding: 24 }}>
      <Space direction="vertical" size={16} style={{ width: '100%' }}>
        <div>
          <Space wrap style={{ marginBottom: 12 }}>
            <Button
              icon={<ArrowLeftOutlined />}
              onClick={() => navigate('/platform/saas-billing/runtime/history')}
            >
              Voltar para Runtime History
            </Button>
            <Button
              type="primary"
              ghost
              onClick={() =>
                navigate(
                  `/platform/saas-billing/runtime/executions/${encodeURIComponent(
                    normalizedExecutionId
                  )}/retry-preview`
                )
              }
            >
              Preview Retry
            </Button>
          </Space>
          <Title level={2} style={{ margin: 0 }}>
            Runtime Execution Detail
          </Title>
          <Text type="secondary">Visao read-only da execucao e timeline operacional.</Text>
        </div>

        <RuntimeExecutionDetailPanel executionId={normalizedExecutionId} />
      </Space>
    </div>
  );
};

export default PlatformRuntimeExecutionDetail;
